import React from "react";
import NavBar from "../../components/NavBar";
import { useHistory } from "react-router-dom";
import { AppContext } from '../../AppContext';
import Footer from "../../components/SessionFooter";


  const TailCondition: React.SFC<{}> = () => {

    const context = React.useContext(AppContext);
    let state = context.state;
    let history = useHistory();

    const normalHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.tailCondition = "normal";
      context.setState(state);
      history.push('/receipt');
    }

    const dockedHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.tailCondition = "docked";
      context.setState(state);
      history.push('/docked_area');
    }

    const injuredHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.tailCondition = "injured";
      context.setState(state);
      history.push('/tail_injury');
    }

    const backHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.tailCondition = "";
      context.setState(state);
      history.push('/enter_tag');
    }

    return (
      <>
        <NavBar
          backBtnTitle="Back"
          backBtnClick={backHandler}
          tag={context.state.current.tagNumber}
        />
        <h1>Tail Condition</h1>
    		<div className="content-pane">
          <button className="rpg_button" onClick={ normalHandler } >NORMAL</button>
          <button className="rpg_button" onClick={ dockedHandler } >DOCKED</button>
          <button className="rpg_button" onClick={ injuredHandler } >INJURED</button>	      
    		</div>
        <Footer tag={state.previous.tagNumber} />
      </>
     )
  }

  

export default TailCondition;